module.exports = __webpack_public_path__ + "media/Office.17498d5b.mp3";